/**
 * Pure constants for the Expenses module. No side effects — safe to import
 * from any modal or helper.
 */

export const EXPENSE_CATEGORIES = [
  '🍽️ Meals & Entertainment',
  '✈️ Travel & Transportation',
  '📦 Office Supplies',
  '🏢 Rent & Utilities',
  '💼 Professional Services',
  '🚗 Vehicle & Fuel',
  '📱 Phone & Internet',
  '🛠️ Repairs & Maintenance',
  '📚 Training & Education',
  '💰 Other Business Expenses',
];

export const PAYMENT_METHODS = ['Cash', 'Credit Card', 'Debit Card', 'Bank Transfer', 'Check'];

// Quick expense presets — single-click "I just spent X on Y" entries
export const QUICK_EXPENSES = [
  { name: 'Coffee', amount: 5.0, category: '🍽️ Meals & Entertainment', icon: '☕' },
  { name: 'Lunch', amount: 15.0, category: '🍽️ Meals & Entertainment', icon: '🍱' },
  { name: 'Gas', amount: 50.0, category: '🚗 Vehicle & Fuel', icon: '⛽' },
  { name: 'Parking', amount: 10.0, category: '✈️ Travel & Transportation', icon: '🅿️' },
  { name: 'Supplies', amount: 25.0, category: '📦 Office Supplies', icon: '📎' },
  { name: 'Uber/Lyft', amount: 20.0, category: '✈️ Travel & Transportation', icon: '🚗' },
];

// Default monthly budget limits per category — used as seed when user hasn't
// customized their budgets yet.
export const DEFAULT_BUDGETS = {
  '🍽️ Meals & Entertainment': 500,
  '✈️ Travel & Transportation': 300,
  '📦 Office Supplies': 200,
  '🏢 Rent & Utilities': 2000,
  '💼 Professional Services': 500,
  '🚗 Vehicle & Fuel': 400,
  '📱 Phone & Internet': 150,
  '🛠️ Repairs & Maintenance': 300,
  '📚 Training & Education': 200,
  '💰 Other Business Expenses': 500,
};
